import React from 'react';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyRoleBasedNotificationDetail = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-role-based-notifications-detail", jiraSpaEntry: "async-jira-eoc-role-based-notifications-detail" */ '@atlassian/jira-eoc-role-based-notifications'
	).then((module) => module.RoleBasedNotificationDetail),
);

export const RoleBasedNotificationDetail = (): React.JSX.Element => (
	<LazyPage
		Page={LazyRoleBasedNotificationDetail}
		pageId="async-jira-eoc-role-based-notifications"
		shouldShowSpinner={false}
	/>
);
